import heroImage from "../../assets/images/hero-gif.gif";

function Hero() {
    return (
        <section
            className="hero"
            style={{ backgroundImage: `url(${heroImage})` }}
        >
            <div className="hero-overlay" />

            <div className="hero-content">
                <h1 className="hero-title">
                    Fii activ. Trăiește mai bine.
                </h1>

                <p className="hero-subtitle">
                    Antrenori profesioniști, echipamente moderne și rezultate reale.
                </p>

                <div className="hero-buttons">
                    {/* butoane */}
                </div>
            </div>
        </section>
    );
}

export default Hero;